import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/content';
import { Reveal } from './Reveal';
export function PainSection() {
  return <section className="bg-paper-soft px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="realidad" data-id="element-205" data-mp="38vu706n62332">
      <div className="mx-auto max-w-6xl" data-id="element-206" data-mp="2v0i5ngei9ed6">
        <Reveal data-id="element-207" data-mp="2yypkg5pes5lq">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-ink-dim" data-id="element-208" data-mp="2yy606icad54j">
            La realidad de dirigir en el barrio
          </p>
          <h2 id="realidad" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-209" data-mp="2pyst1wbmwsmz">
            ¿Entrenás fútbol? Estos problemas te suenan
          </h2>
          <p className="mt-6 max-w-readable text-lg text-ink-soft" data-id="element-210" data-mp="2g8hme20kg5ce">
            ¿Cuánto tiempo más estás dispuesto a improvisar?
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-x-12 gap-y-6 sm:grid-cols-2" data-id="element-211" data-mp="22buckynilkp2">
          {pains.map((pain, i) => <Reveal key={pain} delay={i * 0.03} data-id="element-212" data-mp="3rn0t9io8aq64" data-mpi={i}>
              <li className="flex items-start gap-3 border-b border-paper-line pb-5 text-[17px] leading-snug text-ink" data-id="element-213" data-mp="3rlpphius9if0">
                <XIcon className="mt-1 h-5 w-5 shrink-0 text-ink/40" aria-hidden="true" data-id="element-214" data-mp="3nl5vgo5iaux3" />
                {pain}
              </li>
            </Reveal>)}
        </ul>

        <Reveal data-id="element-215" data-mp="38wj41o2lucpi">
          <p className="display mt-14 max-w-3xl text-2xl leading-tight text-ink sm:text-4xl" data-id="element-216" data-mp="38vzw906o54p7">
            El problema no sos vos.
            <br data-id="element-217" data-mp="33yrbcru4ymk9" />
            <span className="text-ink-dim" data-id="element-218" data-mp="33z9iijic6l6y">
              Es que estás intentando construir una casa sin planos.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}